import { render, staticRenderFns } from "./EmailCobrancaView.vue?vue&type=template&id=43211544&scoped=true"
import script from "./EmailCobrancaView.vue?vue&type=script&lang=js"
export * from "./EmailCobrancaView.vue?vue&type=script&lang=js"
import style0 from "./EmailCobrancaView.vue?vue&type=style&index=0&id=43211544&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43211544",
  null
  
)

export default component.exports